/* eslint-disable react/prop-types */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Select, SelectOption } from '@americanexpress/dls-react';
import { FxFormItem } from './FxFormItem';
import { getFieldStatus, getFieldErrorMessage } from '../../../utils/formUtils';

const getOptions = (options, selectOptionFields) => {
  const markup = [];
  options.forEach((option) => {
    markup.push(
      <SelectOption
        key={option[selectOptionFields.id]}
        id={option[selectOptionFields.id]}
        value={option[selectOptionFields.value]}
        disabled={option[selectOptionFields.disabled]}
      >
        {option[selectOptionFields.name]}
      </SelectOption>
    );
  });

  return markup;
};

export const FxSelectField = ({
  id,
  label,
  isRequired,
  className,
  canExecuteFieldOnChange = true,
  input: {
 value, onChange, onBlur, onFocus,
},
  meta,
  handleOnChange = () => {},
  handleOnBlur = () => {},
  handleOnFocus = () => {},
  options = [],
  selectOptionFields = {
    id: 'id',
    name: 'name',
    value: 'value',
    disabled: 'disabled',
  },
  selectOptions = [],
  showEmptyOption = true,
  emptyOptionValue = '',
  isFluid,
  ...restProps
}) => {
  const status = getFieldStatus(meta, value);
  const errorMessage = getFieldErrorMessage(meta, status);

  return (
    <FxFormItem
      id={id}
      className={className}
      label={label}
      isRequired={isRequired}
      isDisabled={restProps.disabled}
      status={status}
      errorMessage={errorMessage}
      {...restProps}
    >
      <Select
        id={id}
        value={value}
        fluid={isFluid}
        status={status}
        onChange={(e) => {
          if (canExecuteFieldOnChange) onChange(e);
          handleOnChange(e);
        }}
        onBlur={(e) => {
          onBlur(e);
          handleOnBlur(e);
        }}
        onFocus={(e) => {
          onFocus(e);
          handleOnFocus(e);
        }}
        {...restProps}
      >
        {showEmptyOption && (
          <SelectOption value="">{emptyOptionValue}</SelectOption>
        )}
        {selectOptions.length > 0
          ? selectOptions
          : getOptions(options, selectOptionFields)}
      </Select>
    </FxFormItem>
  );
};

// FxSelectField.propTypes = {
//   id: PropTypes.string.isRequired,
//   label: PropTypes.string.isRequired,
//   isRequired: PropTypes.bool,
//   className: PropTypes.string,
//   canExecuteFieldOnChange: PropTypes.bool,
//   input: PropTypes.shape({
//     value: PropTypes.string.isRequired,
//     onChange: PropTypes.func.isRequired,
//     onBlur: PropTypes.func.isRequired,
//     onFocus: PropTypes.func.isRequired,
//   }).isRequired,
//   meta: PropTypes.shape({}).isRequired,
//   handleOnChange: PropTypes.func,
//   handleOnBlur: PropTypes.func,
//   handleOnFocus: PropTypes.func,
//   options: PropTypes.arrayOf(PropTypes.shape({})),
//   showEmptyOption: PropTypes.bool,
//   emptyOptionValue: PropTypes.string,
//   selectOptions: PropTypes.arrayOf(),
// };
